import { HttpHeaders, HttpParams } from '@angular/common/http';

// HEADERS: Constante que guarda las cabeceras que se enviarán en los servicios
export const HEADERS: {
    headers?: HttpHeaders | { [header: string]: string | string[]; };
    params?: HttpParams | { [param: string]: string | string[]; };
    withCredentials?: boolean;
    reportProgress?: boolean;
    responseType: any;
    observe: any;
} = { responseType: "json", reportProgress: true, observe: "events" };
